import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconZapOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], f = /* @__PURE__ */ a("path", { d: "M6.699.541a.5.5 0 0 1 .297.52l-.295 2.376a.5.5 0 0 1-.992-.124l.085-.683-.125.15a.5.5 0 0 1-.768-.64L6.116.68a.5.5 0 0 1 .583-.139ZM7.33 5a.5.5 0 0 1 .5-.5h2.67a.5.5 0 0 1 .384.82L9.669 6.777a.5.5 0 0 1-.768-.641l.53-.635H7.83a.5.5 0 0 1-.5-.5Zm-1.446 6.32a.5.5 0 0 1-.88-.382l.43-3.438H1.5a.5.5 0 0 1-.384-.82l2.208-2.65L.646 1.355a.5.5 0 1 1 .708-.708l10 10a.5.5 0 0 1-.708.708L8.034 8.74l-2.15 2.58Zm.324-1.95.272-2.182.844.843L6.208 9.37ZM5.793 6.5H2.568l1.466-1.76L5.793 6.5Z" }, null, -1), h = [
  f
], p = ["id"], m = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  m
];
function I(e, L, l, v, Z, t) {
  return n(), r("svg", {
    "aria-label": l.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--zap-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Zap Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, h, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, p)
    ])
  ], 10, _);
}
const H = /* @__PURE__ */ s(c, [["render", I]]);
export {
  H as default
};
//# sourceMappingURL=zap-off.js.map
